/**
 * Password limits shared by the forms that set a password.
 *
 * bcrypt reads at most 72 bytes, and the backend rejects longer passwords
 * (backend/app/auth/password_policy.py). The limit is in UTF-8 bytes, not
 * characters: 72 bytes is only 36 Cyrillic or Greek letters, so the error
 * message must never name a character count.
 */
export const PASSWORD_MAX_BYTES = 72;

const encoder = new TextEncoder();

export function isPasswordTooLong(password: string): boolean {
  return encoder.encode(password).length > PASSWORD_MAX_BYTES;
}
